var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncinerationCannon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2201_52570)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.651 19.2465C117.651 19.2465 114.339 15.7125 113.244 14.8245C112.149 13.9365 109.677 13.9035 109.677 13.9035L81.9736 14.1915L78.3421 12.9105L77.5816 12.2355L75.3286 12.4695L74.2021 13.671C74.2021 13.671 73.6111 12.9105 73.0621 12.5175C72.5131 12.1245 70.6531 12.1065 70.6531 12.1065L60.3061 10.68L57.4126 9.40048L56.5486 8.60248H47.8486L36.3616 10.2915H18.5386L7.48057 11.751L3.16507 12.0645L1.90507 13.2465L2.31907 14.7675L3.58657 15.2745L2.79757 15.5835C2.79757 15.5835 1.90657 16.4715 1.59757 17.583C1.28857 18.6945 3.13657 20.2575 3.13657 20.2575L1.11007 20.595C1.11007 20.595 0.0405682 21.2145 6.81481e-05 22.6215C-0.0404319 24.0285 1.11007 25.212 1.11007 25.212H5.44657V27.69L3.58807 27.747C3.58807 27.747 3.27307 28.011 2.63107 29.5425C1.98907 31.074 3.42007 32.259 3.42007 32.259H8.03707L8.54407 33.0435C8.54407 33.0435 11.6686 33.597 11.9581 33.6645C12.2476 33.732 13.4716 34.3635 13.4716 34.3635L14.1466 35.3775L31.9696 35.4615L32.6461 36.306L40.2646 36.252L38.3041 37.7415L37.6876 42.948L37.7971 43.992L37.6276 49.6515L36.6421 52.692V54.318L38.3881 54.636L38.9881 54.063L40.4146 52.1865L41.4541 50.3055L42.3211 47.217L43.1176 42.303L45.3976 40.9515L47.0116 41.0715L50.2126 43.2315H54.1831L55.6186 42.387H62.7136C62.7136 42.387 66.2926 38.6625 67.7791 37.428C69.2656 36.1935 72.1231 35.136 72.2911 35.0805C72.4591 35.025 75.4456 34.5075 75.6091 34.3635C75.7726 34.2195 78.5086 34.356 78.5086 34.356L81.0736 34.068L82.6711 33.549C82.6711 33.549 86.5336 31.5195 87.0391 31.197C87.5461 30.873 89.9251 31.0125 89.9251 31.0125L93.5431 30.987L94.7251 27.609L111.113 24.483L113.277 24.282L116.519 24.06L118.461 22.1175L117.648 19.245L117.651 19.2465ZM55.6201 39.687C54.2116 41.0385 52.0726 41.0385 50.5516 40.362C49.0306 39.687 47.1736 37.0395 47.0596 36.138C46.9471 35.2365 46.9771 33.5145 47.8351 32.799L49.4251 32.0835L52.5226 33.717L54.0436 33.7995L55.6201 36.2535C55.6201 36.2535 57.0286 38.334 55.6201 39.6855V39.687ZM62.2081 38.673C59.2741 39.0105 58.0411 36.8715 57.8716 35.745C57.7021 34.6185 58.3216 33.7995 58.3216 33.7995L65.1736 33.9255C65.1736 33.9255 65.4181 34.674 65.4181 35.5755C65.4181 36.477 64.4566 38.4135 62.2081 38.673ZM110.975 19.584H97.0096L95.8831 18.852V17.895L96.7051 16.206H110.609L111.482 16.6005L111.876 17.952L110.975 19.5855V19.584Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2073 19.2464H83.6063L80.1713 18.2339L79.9463 16.4879L85.5218 15.924L96.7043 16.2059",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8467 16.0604L70.4857 16.8254L74.7652 16.0604L75.6097 16.4429L75.9472 17.3324C75.9472 17.3324 75.4972 18.2339 75.3277 18.2339C75.1582 18.2339 70.9912 19.2479 70.9912 19.2479L70.4842 16.8269",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9492 17.3325L87.3237 21.162H94.8702C94.8702 21.162 97.1787 20.937 98.1357 21.162C99.0927 21.387 101.346 22.0635 101.346 22.0635L118.465 22.1205",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.521 24.0616L90.4206 23.4706L75.3291 18.2341",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7656 16.0605L75.9491 14.46L82.2551 13.926",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9491 14.46L73.4141 13.926",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5215 27.6089L90.9275 25.6154H105.339",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.127 28.9321L88.8994 27.6091H94.7285",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4486 19.2465H15.1446C14.5382 19.2465 14.0466 19.7381 14.0466 20.3445C14.0466 20.9509 14.5382 21.4425 15.1446 21.4425H32.4486C33.055 21.4425 33.5466 20.9509 33.5466 20.3445C33.5466 19.7381 33.055 19.2465 32.4486 19.2465Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44531 27.6945H8.03581",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26172 32.1989H27.6672",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44531 25.2165H8.88031",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4676 22.6261H11.0771V18.2341H13.4711H39.4676V22.6261Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4707 18.2339V22.6259",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0234 18.2339V22.6259",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03735 15.5865V19.923",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98145 20.5815V25.2165",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44531 27.6945V32.262",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3132 29.9999L39.4677 34.3664H37.7967L33.9387 31.3034L29.8152 28.0319H26.3937L21.1152 29.0024L33.9387 31.3034",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9883 26.6804H30.9973L33.9538 29.1299V29.9774L38.0938 33.1424L46.1593 28.9604L45.5263 28.0319L39.4678 28.1999L38.4313 27.0749L37.3753 25.9484",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7363 33.5219H33.4698",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8057 15.84L21.1152 13.6725H36.4452L38.0502 14.094L42.7812 14.3475L53.7192 13.2495L55.9152 17.304",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9928 12.1515L54.7328 11.772L53.7188 13.2495L42.0488 17.1075",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3213 17.6535L45.8628 19.5855L46.3278 18.6195L49.5798 20.43L52.8738 19.6695C52.8738 19.6695 52.1133 18.2055 54.0138 17.7555C55.9143 17.3055 56.7168 17.052 56.7168 17.052L57.4353 15.588L59.5608 15.279L59.9988 15.561C59.9988 15.561 60.4053 15.279 61.1373 15.3915C61.8693 15.504 62.9673 16.2645 62.9673 16.2645",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9927 19.2465L66.0937 18.459L61.9822 20.2605",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8597 10.293C23.8597 10.293 23.6062 10.842 23.8597 11.2215C24.1132 11.601 24.3832 11.7705 24.9877 11.7705H35.2627L37.8607 11.3475L39.4672 9.85345",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16286 12.5745L8.88086 13.884L14.7369 13.6725L15.0324 11.772L9.16286 12.5745Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36328 12.8279H7.38828L8.03628 15.5864H13.8503L20.4968 14.6954",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9686 22.2269H50.5521L36.6426 25.7069L50.5521 22.2269L45.8631 19.5854",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9418 14.4405C59.366 14.4405 59.7098 14.0966 59.7098 13.6725C59.7098 13.2483 59.366 12.9045 58.9418 12.9045C58.5177 12.9045 58.1738 13.2483 58.1738 13.6725C58.1738 14.0966 58.5177 14.4405 58.9418 14.4405Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32048 14.7705L1.81348 12.912L3.16498 12.0675L7.81048 11.73L18.5385 10.2945H36.5295L47.8485 8.60547H56.5485L57.6465 9.61947L60.603 10.8015L70.992 12.153C70.992 12.153 73.0185 12.153 73.611 12.9135L74.202 13.674L75.4695 12.3225L77.5815 12.2385L78.342 12.9135L81.8055 13.9275H108.919C108.919 13.9275 112.213 13.59 114.156 15.5325L116.098 17.475L117.873 19.5015L118.464 22.1205L116.521 24.063H115.677L111.115 24.486L94.728 27.696L93.546 30.99C93.546 30.99 88.4775 30.7935 86.535 31.5255C84.5925 32.2575 83.409 33.4395 81.636 33.9465C79.8615 34.4535 74.4555 34.5375 74.4555 34.5375C74.4555 34.5375 70.992 35.0445 68.0355 37.2405C65.079 39.4365 62.7135 42.393 62.7135 42.393H55.6185L54.183 43.2375H50.2125L46.8345 40.9575H45.399L43.119 42.309C43.119 42.309 42.696 45.687 42.105 48.222C41.514 50.7555 40.2465 52.8675 40.2465 52.8675L38.388 54.642L36.5295 54.3045L36.699 52.53L37.6275 49.6575L37.797 43.998C37.797 43.998 37.5435 42.9 37.797 41.5485C38.0505 40.197 38.304 37.7475 38.304 37.7475L40.416 36.1425L32.6445 36.312L31.9695 35.4675L14.1465 35.3835C14.1465 35.3835 13.893 34.2015 12.372 33.7785C10.851 33.3555 8.31748 33.018 8.31748 33.018L8.26048 32.202L3.19198 32.3145C3.19198 32.3145 1.05148 29.6685 3.58648 27.753L5.44498 27.696V25.218H1.10998C1.10998 25.218 -1.19852 22.74 1.10998 20.601L10.458 20.544L10.6275 19.9245H2.80048C2.80048 19.9245 0.0974844 17.4465 2.80048 15.588H4.03948L3.98248 15.0255L2.32198 14.772L2.32048 14.7705Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98267 15.024H7.81217L8.31917 16.656H13.7252L19.8062 15.84L37.8827 16.0935L42.0497 17.1075L42.7817 18.5715L44.0207 21.5565L38.6147 22.7385L34.3352 25.9485H28.1402L20.8757 27.6375H8.03717L9.33167 30.2835L24.7052 31.5225L34.3352 33.7185L37.3772 36.207",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.416 36.141L49.4265 32.0865L52.524 33.7185L58.323 33.801L80.2845 34.113L85.128 30.6225V28.2L85.5225 27.018L85.2405 25.8915L81.468 24.822H76.9065L73.7535 26.568L74.9355 27.807L77.469 26.286H80.679L82.425 27.4125L82.4805 28.989L79.779 31.6215H75.3855L72.234 33.999L75.3855 31.6215L75.4425 28.8195H48.018L49.4265 32.0865",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2035 13.6725L62.9685 16.263L62.7165 17.388L61.365 18.1215L53.3685 19.7535L61.983 20.2605L68.91 24.822L68.403 26.511H46.329L45.315 27.075H40.698L39.5145 25.9485H34.335",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3708 30.2549C79.1015 30.2549 79.6938 29.6626 79.6938 28.9319C79.6938 28.2012 79.1015 27.6089 78.3708 27.6089C77.6402 27.6089 77.0479 28.2012 77.0479 28.9319C77.0479 29.6626 77.6402 30.2549 78.3708 30.2549Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3227 33.801C58.3227 33.801 57.7047 34.62 57.8727 35.7465C58.0407 36.873 59.2737 39.012 62.2092 38.6745C64.4577 38.415 65.4192 36.4785 65.4192 35.577C65.4192 34.6755 65.1747 33.927 65.1747 33.927L58.3227 33.801V33.801Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8361 32.8019C46.9781 33.5174 46.9481 35.2394 47.0606 36.1409C47.1731 37.0424 49.0316 39.6884 50.5526 40.3649C52.0736 41.0399 54.2126 41.0399 55.6211 39.6899C57.0296 38.3384 55.6211 36.2579 55.6211 36.2579L54.0446 33.8039L52.5236 33.7214L49.4261 32.0879L47.8361 32.8034V32.8019Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7048 16.2061H110.608L111.481 16.6006L111.876 17.9521L110.974 19.5856H97.0093L95.8828 18.8536V17.8951L96.7048 16.2061Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88159 25.104C8.88159 25.104 9.38859 26.2305 11.7541 26.286C14.1196 26.343 22.5091 26.286 22.5091 26.286L23.4106 25.707V25.1025H8.88159V25.104Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2201_52570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncinerationCannon);
export default __webpack_public_path__ + "static/media/Incineration Cannon.a96ce7e3f79845cdb0a886b0af73c5d4.svg";
export { ForwardRef as ReactComponent };